<script>
  import { onMount } from 'svelte'
  import {fade} from 'svelte/transition'

  import TabulatorBare from '../../UC-tabulator-bare.svelte'
  import Legend from './3rdPartyLegend.svelte'

  import {
    dag3PStatusIconFormatter,
  } from '../../../shared/utils'

  export let tableTitle = 'Third-party Data'

  // export let tableTotalEnrolled = 0
  // export let tableNumberComplete = 0
  // export let tableNumberNotComplete = 0
  // export let tableNumberExempt = 0
  export let tableData
  export let loading
  export let error
  

  // We'll bind this to the instance of TabulatorBare so we can call its exported download function from exportData()
  let tabulatorComponentRef = undefined

  const tableColumns = [
    { title: "<span class='title'>Product</span>", field:"ProductName", minWidth: 100 },
    { title: "<span class='title'>Requested</span>", field: "OrgUnitName", minWidth: 134 },
    { title: "<span class='title'>Department</span>", field: "DepartmentName", minWidth: 134 },
    { 
      title: "<span class='title'>Status</span>", field:"FinalRecommendation",
      formatter: dag3PStatusIconFormatter,
      minWidth: 90,
      maxWidth: 125,
      hozAlign:"center",
    },
  ]

  $: if(tableData && tabulatorComponentRef && tabulatorComponentRef.setData) {
    tabulatorComponentRef.setData(tableData)
  }

  const exportData = ()=>{
    if(tabulatorComponentRef) {
      tabulatorComponentRef.triggerDownload('third-party-software-export')
    }
  }
</script>

<div class="uc-tabulator third-party-tabulator w-full" aria-live="polite">
  <header>
    <div class="table-title">
      <h3>{ tableTitle }</h3>
    </div>
    
  </header>
  {#if $loading}
    <div class="loading">
      <p><i class="fa-solid fa-spinner fa-spin"></i> Loading third party software data...</p>
    </div>
  {:else if $error || $tableData.error}
    <div class="error" transition:fade>
      <p>There was an error loading the third party software data.</p>
    </div>
  {:else}
    <span transition:fade>
      <TabulatorBare bind:this={ tabulatorComponentRef } data={ $tableData } columns={ tableColumns } />
      <Legend />
    </span>
  {/if}
</div>
<div class="export-wrap">
  <button on:click={ exportData }>Download CSV</button>
</div>

<span class="hidden tabulator-row tabulator-cell sr-only table-filter"></span>

<style>
  .third-party-tabulator, .w-full {
    width: 100%;
  }

  div.loading, div.error {
    padding: 4rem;
    text-align: center;
    display: grid;
    justify-content: center;
    align-items: center;
  }

  .loading i {
    color: var(--uc-red);
  }

  h3 {
    color: var(--uc-red);
    font-size: 3rem;
    font-weight: 600;
    padding: 2rem 0;
  }

  .uc-tabulator {
    border-radius: 1rem;
    background-color: #FFF;
    filter:drop-shadow(0.2em 0.2em 0.2em rgba(0, 0, 0, 0.15));
    margin-bottom: 3rem;
  }

  .sr-only {
    display: none;
  }

  header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  @media(max-width:768px){
    header {
      flex-direction: column;
      align-items: center;
    }
  }

  .table-filter {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    padding: 2rem 0rem 0rem;
  }

  @media(max-width:768px){
    .table-filter {
      display: flex;
      justify-content:left;
      flex-wrap: wrap;
    }
  }

  @media(max-width: 600px){
    .table-filter {
      margin: 1rem;
      flex-direction: column;
    }
  }

  .table-title {
    color: var(--uc-red);
    padding: 0 2rem;
  }

  .export-wrap {
    text-align: right;
  }

  .export-wrap button {
    background-color: var(--uc-red);
    border: 1px solid #fff;
    color: #fff;
    border-radius: .25em;
  }
</style>